<template>
  <Doughnut :chartData="chartData" :chartOptions="chartOptions" />
</template>

<script setup>
import { toRefs } from 'vue'
import { Doughnut } from 'vue-chartjs'
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  CategoryScale,
} from 'chart.js'
import _ from 'lodash'

ChartJS.register(Title, Tooltip, Legend, ArcElement, CategoryScale)

// eslint-disable-next-line
const props = defineProps({
  chartData: {
    type: Object,
    default() {
      return {
        labels: ['VueJs', 'EmberJs', 'ReactJs', 'AngularJs'],
        datasets: [
          {
            backgroundColor: ['#41B883', '#E46651', '#00D8FF', '#DD1B16'],
            data: [40, 20, 80, 10],
          },
        ],
      }
    },
  },
  chartOptions: {
    type: Object,
    default() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: 'right',
            onClick(e, legendItem, legend) {
              legend.chart.toggleDataVisibility(legendItem.index)
              legend.chart.update()
            },
            labels: {
              color: '#fff',
              boxWidth: 12,
              boxHeight: 12,
              font: {
                size: 16,
              },
              padding: 20,
              generateLabels(chart) {
                const data = chart.data
                if (data.labels.length && data.datasets.length) {
                  const {
                    labels: { pointStyle },
                  } = chart.legend.options

                  const meta = chart.getDatasetMeta(0)
                  const datas = meta.controller.getDataset(0)
                  const total = _.sum(datas.data)
                  return data.labels.map((label, i) => {
                    const style = meta.controller.getStyle(i)
                    let length = 15
                    if (label.length === 4) {
                      length -= 5
                    } else if (label.length == 3) {
                      length -= 3
                    }
                    const text = label.padEnd(length, '\u0020')
                    const count = datas.data[i]
                    const percentage = parseInt((count / total) * 100)

                    return {
                      text: `${text}${count}(${percentage}%)`,
                      fillStyle: style.backgroundColor,
                      strokeStyle: style.borderColor,
                      lineWidth: style.borderWidth,
                      pointStyle: pointStyle,
                      hidden: !chart.getDataVisibility(i),
                      index: i,
                      datasetIndex: 1,
                    }
                  })
                }
                return []
              },
            },
          },
        },
      }
    },
  },
})
const { chartData, chartOptions } = toRefs(props)
</script>
